import {
    GET_PRE_REGISTRATIONS_FAIL,
    GET_PRE_REGISTRATIONS_SUCCESS,
    
    ADD_PRE_REGISTRATION_SUCCESS,
    ADD_PRE_REGISTRATION_FAIL,

    UPDATE_PRE_REGISTRATION_SUCCESS,
    UPDATE_PRE_REGISTRATION_FAIL,

    DELETE_PRE_REGISTRATION_SUCCESS,
    DELETE_PRE_REGISTRATION_FAIL,

    // SELECTED PRE
    SET_SELECTED_PRE_REGISTRATION,

    // FOR APPROVE PRE REGISTRATION
    APPROVE_PRE_REGISTRATION,
    APPROVE_PRE_REGISTRATION_SUCCESS,
    APPROVE_PRE_REGISTRATION_FAIL,

    // FOR REJECT PRE REGISTRATION
    REJECT_PRE_REGISTRATION,
    REJECT_PRE_REGISTRATION_SUCCESS,
    REJECT_PRE_REGISTRATION_FAIL,

    RESET_PRE_REGISTRATION_ACTION,

    GET_PRE_REGISTRATION_BY_UUID_FAIL,
    GET_PRE_REGISTRATION_BY_UUID_SUCCESS,


} from "./actionTypes";

const INIT_STATE = {
    preRegistrations: [],
    selectedPreRegistration: null,
    error: null,
    loading: true,

    approveLoading: false,
    rejectLoading: false,

    actionSuccess: false,
};

const preRegistrationReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des preRegistrations
        case GET_PRE_REGISTRATIONS_SUCCESS:
            return {
                ...state,
                preRegistrations: action.payload, // tableau d'objets preRegistration
                loading: false,
                error: null
            };

        case GET_PRE_REGISTRATIONS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une preRegistratione
        case ADD_PRE_REGISTRATION_SUCCESS:
            return {
                ...state,
                preRegistrations: [action.payload, ...state.preRegistrations], // ajoute au début du tableau
                error: null
            };

        case ADD_PRE_REGISTRATION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une preRegistratione
        case UPDATE_PRE_REGISTRATION_SUCCESS:
            return {
                ...state,
                preRegistrations: state.preRegistrations.map(preRegistration =>
                    preRegistration.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet preRegistration
                        : preRegistration
                ),
                error: null
            };

        case UPDATE_PRE_REGISTRATION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une preRegistratione
        case DELETE_PRE_REGISTRATION_SUCCESS:
            return {
                ...state,
                preRegistrations: state.preRegistrations.filter(
                    preRegistration => preRegistration.id !== action.payload
                ),
                error: null
            };


        case DELETE_PRE_REGISTRATION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // FOR SELECT
        case SET_SELECTED_PRE_REGISTRATION:
            return {
                ...state,
                selectedPreRegistration: action.payload,
            };

        case APPROVE_PRE_REGISTRATION:
            return {
                ...state,
                approveLoading: true,
                error: null,
            };
        
    
        case APPROVE_PRE_REGISTRATION_SUCCESS:
            return {
                ...state,
                loading: false,
                actionSuccess: true,
                preRegistrations: state.preRegistrations.map((pr) =>
                pr.id === action.payload.id ? action.payload : pr
                ),
                error: null
            };

        case APPROVE_PRE_REGISTRATION_FAIL:
            return { ...state, loading: false, error: action.payload };

        case REJECT_PRE_REGISTRATION:
            return {
                ...state,
                rejectLoading: true,
                error: null,
            };



        case REJECT_PRE_REGISTRATION_SUCCESS:
            return {
                ...state,
                loading: false,
                actionSuccess: true,
                preRegistrations: state.preRegistrations.map((pr) =>
                pr.id === action.payload.id ? action.payload : pr
                ),
                error: null
            };

        case REJECT_PRE_REGISTRATION_FAIL:
            return { ...state, loading: false, error: action.payload };

        case RESET_PRE_REGISTRATION_ACTION:
            return {
                ...state,
                actionSuccess: false,
                error: null,
            };

        // --------------------- SINGLE PRE_REGISTRATION ---------------------
                
                case GET_PRE_REGISTRATION_BY_UUID_SUCCESS:
                    return {
                        ...state,
                        loading: false,
                        preRegistration: action.payload
                    };
                case GET_PRE_REGISTRATION_BY_UUID_FAIL:
                    return {
                        ...state,
                        loading: false,
                        preRegistration: null,
                        error: action.payload
                    };

        default:
            return state;
    }
};

export default preRegistrationReducer;
